import React from "react";
//imported
import * as Path from "../Path";

//dashboard
import Dashboard from "views/dashboard/Dashboard";

//User
import UserList from "views/users/List";
import Login from "views/auth/Login/Login";
import ForgetPassword from "views/auth/Forget-password/ForgotPassword";
import GeneralSettings from "views/settings/General/index";
import Profile from "views/auth/profile/index";
import ChangePassword from "views/auth/change_password/index";
import MGameSettings from "views/settings/Mini-Game";
import EnerygySetting from "views/settings/Energy";
import LeaderboardSettings from "views/settings/Leaderboard";
import MaintenanceSettings from "views/settings/Maintenance";
import LanguageList from "views/language/List";
import WelcomeBonusSettings from "views/settings/WelcomeBonus";
import PaymentSettings from "views/settings/Payment";
import RewardSettings from "views/settings/Reward-System";
import JackpotSettings from "views/settings/Jackpot";
import WeeklyRewardHistory from "views/weeklyRewardHistory/List";

//game
import GameHistoryList from "views/gameHistory/List";
import GameHistoryView from "views/gameHistory/View";
import GameLeaderboard from "views/gameLeaderboard/List";
import ClaimHistory from "views/claimHistory/List";
import UserView from "views/users/View";
import TasksListPage from "views/tasks/List";
import RoadmapList from "views/roadmap/List";
import EnergyPackageList from "views/energyPackages/List";
import EnergyPurchaseHistory from "views/energyPurchaseHistory/List";
import Statistics from "views/Statistics";
import Logs from "views/Logs/List";
import SubAdminsList from "views/subadmins/List";
import SubAdminView from "views/subadmins/View";
import CryptoExchangeSettings from "views/settings/Crypto-Exchange";
import CryptoDepositSettings from "views/settings/Crypto-Deposit";
import ConversionSettings from "views/settings/Conversion";
import PromotionSettings from "views/settings/Promotion4GB";
import JackpotHistoryList from "views/jackpotHistory/List";
import JackpotHistoryView from "views/jackpotHistory/View";
import HistoricalDataSetting from "views/historicalDataSetting/index";
import MoveToMySQL from "views/movetoMySql/List";
import RemoveFromMongo from "views/removeFromMongo/List";
import CoinHistoryView from "views/coinHistory/List";
import CoinList from "views/coinlist/List";

const routes = [
  {
    path: Path.statistics,
    exact: true,
    auth: false,
    component: <Statistics />,
    permission: ["statistics"],
    is_permission: true,
  },
  {
    path: Path.dashboard,
    exact: true,
    auth: false,
    component: <Dashboard />,
    permission: ["dashboard"],
    is_permission: true,
  },
  {
    path: Path.users,
    exact: true,
    auth: true,
    component: <UserList />,
    permission: ["manage_users", "edit_users"],
    is_permission: true,
  },
  {
    path: Path.usersView,
    exact: true,
    auth: true,
    component: <UserView />,
    permission: ["manage_users", "edit_users"],
    is_permission: true,
  },
  {
    path: Path.login,
    exact: true,
    auth: false,
    fallback: true,
    component: <Login />,
    is_permission: false,
  },
  {
    path: Path.forgot_password,
    exact: true,
    auth: false,
    component: <ForgetPassword />,
    is_permission: false,
  },
  {
    path: Path.changePassword,
    exact: true,
    auth: false,
    component: <ChangePassword />,
    permission: ["change_password"],
    is_permission: true,
  },
  {
    path: Path.game_setting,
    exact: true,
    auth: false,
    component: <MGameSettings />,
    permission: ["game_settings", "edit_game_settings"],
    is_permission: true,
  },
  {
    path: Path.energy_setting,
    exact: true,
    auth: false,
    component: <EnerygySetting />,
    permission: ["energy_settings", "edit_energy_settings"],
    is_permission: true,
  },
  {
    path: Path.leaderboard_setting,
    exact: true,
    auth: false,
    component: <LeaderboardSettings />,
    permission: ["leaderboard_settings", "edit_leaderboard_settings"],
    is_permission: true,
  },
  {
    path: Path.maintenance_setting,
    exact: true,
    auth: false,
    component: <MaintenanceSettings />,
    permission: ["maintenance_settings", "edit_maintenance_settings"],
    is_permission: true,
  },
  {
    path: Path.welcome_bonus_setting,
    exact: true,
    auth: false,
    component: <WelcomeBonusSettings />,
    permission: ["welcome_bonus_settings", "edit_welcome_bonus_settings"],
    is_permission: true,
  },
  {
    path: Path.crypto_exchange_setting,
    exact: true,
    auth: false,
    component: <CryptoExchangeSettings />,
    permission: ["crypto_exchange_settings", "edit_crypto_exchange_settings"],
    is_permission: true,
  },
  {
    path: Path.crypto_deposit_setting,
    exact: true,
    auth: false,
    component: <CryptoDepositSettings />,
    permission: ["crypto_deposit_settings", "edit_crypto_deposit_settings"],
    is_permission: true,
  },
  {
    path: Path.crypto_conversion_setting,
    exact: true,
    auth: false,
    component: <ConversionSettings />,
    permission: ["conversion_settings", "edit_conversion_settings"],
    is_permission: true,
  },
  {
    path: Path.promotion_4gb_setting,
    exact: true,
    auth: false,
    component: <PromotionSettings />,
    permission: ["promotion_settings", "edit_promotion_settings"],
    is_permission: true,
  },
  {
    path: Path.payment_setting,
    exact: true,
    auth: false,
    component: <PaymentSettings />,
    permission: ["payment_setting", "edit_payment_setting"],
    is_permission: true,
  },
  {
    path: Path.reward_system_settings,
    exact: true,
    auth: false,
    component: <RewardSettings />,
    permission: ["reward_system_settings", "edit_reward_system_settings"],
    is_permission: true,
  },
  {
    path: Path.jackpot_settings,
    exact: true,
    auth: false,
    component: <JackpotSettings />,
    permission: ["jackpot_settings", "edit_jackpot_settings"],
    is_permission: true,
  },
  // {
  //   path: Path.general_setting,
  //   exact: true,
  //   auth: false,
  //   component: <GeneralSettings />,
  // },

  {
    path: Path.profile,
    exact: true,
    auth: false,
    component: <Profile />,
    permission: ["profile"],
    is_permission: true,
  },

  {
    path: Path.language,
    exact: true,
    auth: false,
    component: <LanguageList />,
    permission: ["language_settings", "edit_language_settings"],
    is_permission: true,
  },
  {
    path: Path.gameHisory,
    exact: true,
    auth: false,
    component: <GameHistoryList />,
    permission: ["game_history"],
    is_permission: true,
  },
  {
    path: Path.gameHisoryView,
    exact: true,
    auth: false,
    component: <GameHistoryView />,
    permission: ["game_history"],
    is_permission: true,
  },
  {
    path: Path.gameLeaderboard,
    exact: true,
    auth: false,
    component: <GameLeaderboard />,
    permission: ["leaderboard", "edit_leaderboard_points"],
    is_permission: true,
  },
  {
    path: Path.claimHistory,
    exact: true,
    auth: false,
    component: <ClaimHistory />,
    permission: ["claim_history"],
    is_permission: true,
  },
  {
    path: Path.tasksList,
    exact: true,
    auth: false,
    component: <TasksListPage />,
    permission: ["tasks", "add_task", "edit_task", "delete_task"],
    is_permission: true,
  },
  {
    path: Path.roadmapsList,
    exact: true,
    auth: false,
    component: <RoadmapList />,
    permission: ["roadmap", "add_roadmap", "edit_roadmap", "delete_roadmap"],
    is_permission: true,
  },
  {
    path: Path.energyPackageList,
    exact: true,
    auth: false,
    component: <EnergyPackageList />,
    permission: [
      "energy_package",
      "add_energy_package",
      "edit_energy_package",
      "delete_energy_package",
    ],
    is_permission: true,
  },
  {
    path: Path.energyPurchaseHistory,
    exact: true,
    auth: false,
    component: <EnergyPurchaseHistory />,
    permission: ["energy_purchase_history"],
    is_permission: true,
  },
  {
    path: Path.logs,
    exact: true,
    auth: true,
    component: <Logs />,
    permission: ["logs"],
    is_permission: true,
  },
  {
    path: Path.coinList,
    exact: true,
    auth: true,
    component: <CoinList />,
    permission: ["coin_list"],
    is_permission: true,
  },
  {
    path: Path.subadmins,
    exact: true,
    auth: true,
    component: <SubAdminsList />,
    permission: ["subadmins"],
    is_permission: true,
  },
  {
    path: Path.subAdminView,
    exact: true,
    auth: true,
    component: <SubAdminView />,
    permission: ["subadmins"],
    is_permission: true,
  },
  {
    path: Path.jackpotHistory,
    exact: true,
    auth: false,
    component: <JackpotHistoryList />,
    permission: ["jackpot_history"],
    is_permission: true,
  },
  {
    path: Path.jackpotHistoryView,
    exact: true,
    auth: false,
    component: <JackpotHistoryView />,
    permission: ["jackpot_history"],
    is_permission: true,
  },
  {
    path: Path.weeklyRewardHistory,
    exact: true,
    auth: false,
    component: <WeeklyRewardHistory />,
    permission: ["weekly_reward_history"],
    is_permission: true,
  },
  {
    path: Path.mongotoMysql,
    exact: true,
    auth: true,
    component: <MoveToMySQL />,
    permission: ["move_data_mySql"],
    is_permission: true,
  },
  {
    path: Path.removefromMongo,
    exact: true,
    auth: true,
    component: <RemoveFromMongo />,
    permission: ["remove_data_mongoDb", "delete_data_from_mongoDb"],
    is_permission: true,
  },

  {
    path: Path.historicalDataSetting,
    exact: true,
    auth: true,
    component: <HistoricalDataSetting />,
    permission: ["historical_data_setting"],
    is_permission: true,
  },
  {
    path: Path.coinHistory,
    exact: true,
    auth: false,
    component: <CoinHistoryView />,
    permission: ["coin_history"],
    is_permission: true,
  },
];

export default routes;
